import React from "react";
import PropTypes from "prop-types";

import SlideElectricMilesPortionForPhev from "../InputComponents/SlideElectricMilesPortionForPhev/SlideElectricMilesPortionForPhev";
import SlideInterestRateAsBasisPoints from "../InputComponents/SlideInterestRateAsBasisPoints/SlideInterestRateAsBasisPoints";
import SlideMilesDrivenAnnually from "../InputComponents/SlideMilesDrivenAnnually/SlideMilesDrivenAnnually";
import SlideMonthsOfOwnership from "../InputComponents/SlideMonthsOfOwnership/SlideMonthsOfOwnership";
import SelectPurchaseMethod from "../InputComponents/SelectPurchaseMethod/SelectPurchaseMethod";
import isPHEV from "../../functions/vehicle/isPHEV";

const CostOfOwnershipOptions = ({ cars }) => {
  if (!cars || cars.length === 0) return null
  const phevExists = cars.some(car => isPHEV(car))

  let renderElectricMilesPortionForPhev = phevExists ? (
    <SlideElectricMilesPortionForPhev />
  ) : null;

  return (
    <div className="input-well">
      <SelectPurchaseMethod />
      <SlideMilesDrivenAnnually />
      {renderElectricMilesPortionForPhev}
      <SlideMonthsOfOwnership />
      <SlideInterestRateAsBasisPoints />
    </div>
  );
};

CostOfOwnershipOptions.propTypes = {
  car: PropTypes.object
};
export default CostOfOwnershipOptions;
